var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"webinar mb-2"},[(_vm.webinar)?_c('b-card',{attrs:{"title":_vm.webinar.title}},[_c('b-card-text',[_c('clock-icon'),_vm._v(" "+_vm._s(_vm.startDate)+"   "),_c('b-badge',{attrs:{"variant":"info"}},[_vm._v(_vm._s(_vm.badgeLabel))])],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }